// extracted by mini-css-extract-plugin
module.exports = {"container":"Tooltip_container__RQdCm","primary":"Tooltip_primary__5Nsk3","shimmer":"Tooltip_shimmer___wWX0"};